'use client';

import React, { Suspense } from 'react';
import TrailerSection from '../../components/organisms/trailerSection';
import ShibPortal from '../../components/organisms/shibPortal';
import OnboardingModal from '../../components/organisms/onboardingModalWrapper';
import BuyYourLand from '../../components/organisms/buyYourLand';
import RyoshiPlaza from '../../components/organisms/ryoshiPlaza';
import WhatsNew from '../../components/organisms/whatsNew';
import ShapingFuture from '../../components/organisms/shapingFuture';
import PlotBuilder from '../../components/organisms/plotBuilder';
import LapDogs from '../../components/organisms/lapDogs';
import FaqsSection from '../../components/organisms/faqsSection';
import ShiberseLoader from '../../components/Loader/loader';
import CreditsSection from '../../components/organisms/Credits';

const Index = () => {
  return (
    <div>
      <Suspense fallback={<ShiberseLoader />}>
        <TrailerSection />
        <ShibPortal />
        <OnboardingModal />
        <BuyYourLand />
        <PlotBuilder />
        <RyoshiPlaza />
        <WhatsNew />
        <LapDogs />
        <ShapingFuture />
        <FaqsSection />
        <CreditsSection />
      </Suspense>
    </div>
  );
};

export default Index;
